import { type GeneralFilterGroup } from '../types';

export const PRODUCT_FILTER_ORDER = [
  'departments',
  'sub_departments',
  'seasons',
  'events',
  'brands',
  'styles',
  'collection_types',
  'products',
  'colors',
  'materials',
] as const;

export const LOCATION_FILTER_ORDER = [
  'location_types',
  'regions',
  'countries',
  'from_countries',
  'to_countries',
  'territories',
  'locations',
  'from_locations',
  'to_locations',
] as const;

const collectOrderedGroups = (
  order: readonly string[],
  groupById: Map<string, GeneralFilterGroup>,
  usedIds: Set<string>,
): GeneralFilterGroup[] =>
  order
    .map((id) => groupById.get(id))
    .filter((group): group is GeneralFilterGroup => {
      if (!group) return false;
      usedIds.add(group.id);
      return true;
    });

export const groupGeneralFilterGroups = (
  groups: GeneralFilterGroup[],
): GeneralFilterGroup[] => {
  const groupById = new Map(groups.map((group) => [group.id, group]));
  const usedIds = new Set<string>();

  const productGroups = collectOrderedGroups(
    PRODUCT_FILTER_ORDER,
    groupById,
    usedIds,
  );

  const locationGroups = collectOrderedGroups(
    LOCATION_FILTER_ORDER,
    groupById,
    usedIds,
  );

  const otherGroups = groups.filter((group) => !usedIds.has(group.id));
  return [...productGroups, ...locationGroups, ...otherGroups];
};
